<template>
  <div class="mx-6">
    <v-row>
      <info
        :info.sync="details.group_name"
        title="Group Name"
        id="group-name"
        type="title"
        :cols="9"
      />
      <info
        :info.sync="details.interface"
        select
        :items="_interfaceTypes"
        title="Interface"
        id="group-interface"
        :cols="3"
      />
      <info :info.sync="phone" title="Phone" id="group-phone" phone :cols="3" />
      <info
        :info.sync="details.uuid"
        title="Unique ID"
        id="group-unique-id"
        :cols="3"
      />
      <info
        :info.sync="details.vistar_direct"
        title="vistar_direct"
        id="group-vistar-direct"
        :cols="3"
        select
        vistar
        :items="vistarOptions"
      />
      <info title="Homebase" id="group-homebase" :cols="3">
        <div class="d-flex align-center">
          <v-checkbox
            class="mt-0 pt-2"
            hide-details
            v-model="details.home_base"
          />
          <span class="font-weight-bold pt-2">{{
            details.home_base ? `Yes` : `No`
          }}</span>
        </div>
      </info>
      <info
        :readOnly="true"
        :info.sync="details.code"
        title="Group Code"
        id="group-contact-name"
        :cols="3"
      />
      <info
        :info.sync="contactName"
        title="Contact Name"
        id="group-contact-name"
        :cols="3"
      />
      <info
        :info.sync="details.ad_schedule"
        title="Ad Schedule"
        id="group-ad-schedule"
        :cols="3"
      />
      <info
        :info.sync="area"
        title="Area"
        id="group-area"
        select
        :items="_areas"
        :cols="3"
      />

      <v-col cols="3">
        <div v-if="editable" class="mx-4 mt-n4">
          <VueGooglePlaces
            :api-key="googleKey"
            types="establishment"
            :enableGeolocation="false"
            country="us"
            placeholder="Input your place"
            @placechanged="onPlaceChanged"
          >
            <v-text-field
              color="secondary"
              class="my-5"
              style="height:29px;"
              filled
              placeholder=""
              label="Address"
              v-model="formatedAddress"
            />
          </VueGooglePlaces>
        </div>
        <div v-else class="mx-4">
          <span class="px-2" style="font-size: 12px;">Address</span>
          <div
            class="d-flex align-center text-capitalize text-truncate px-2"
            style="border-bottom: solid 1px black; height:29px;"
          >
            <h3>{{ formatedAddress }}</h3>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row v-if="_client.client_name === 'avis'">
      <info :info.sync="status" title="Status" id="group-status" :cols="3" />
      <info
        :info.sync="computedUtilization"
        title="High Utilization Trigger"
        id="group-high-utilization-trigger"
        :select="true"
        :items="utilization_trigger_options"
        :cols="3"
      />
      <info :info.sync="email" title="Email" id="group-email" :cols="3" />
      <v-col :cols="3">
        <div
          class="d-flex justify-space-between mb-2 mx-4 mt-6"
          id="group-inventory"
        >
          <span style="font-size: 14px; font-weight: bold">Inventory</span>
          <span style="font-size: 14px; font-weight: bold" class="red--text"
            >[{{ details.inventory }}]</span
          >
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import GroupDetailData from '@/mixins/GroupDetailData';
import Info from '@/components/group-details/Info';
import FormatPhone from '@/mixins/FormatPhone';

export default {
  components: {
    Info,
  },
  mixins: [GroupDetailData, FormatPhone],
  data: () => ({
    utilization_trigger_options: [
      '10%',
      '20%',
      '30%',
      '40%',
      '50%',
      '60%',
      '70%',
      '80%',
      '90%',
      '100%',
    ],
    vistarOptions: [
      { text: 'No Vistar', value: 0 },
      { text: 'Vistar Normal', value: 1 },
      { text: 'Vistar Direct', value: 2 },
    ],
  }),
  computed: {
    ...mapGetters({
      _areas: 'areas/getAreas',
      _client: 'account/getCurrentClient',
      _interfaceTypes: 'groupDetails/getInterfaceTypes',
    }),
    googleKey() {
      return process.env.VUE_APP_GOOGLE_MAPS_API_KEY;
    },
    computedUtilization: {
      get() {
        return this.details.tablet_settings
          && this.details.tablet_settings.utilization_trigger
          ? `${this.details.tablet_settings.utilization_trigger.toString()}%`
          : '';
      },
      set(val) {
        this.details.tablet_settings.utilization_trigger = parseInt(
          val.replace(/^\D+/g, ''),
        );
      },
    },
    formatedAddress() {
      return this.details.address
        ? `${this.details.address.address_1}, ${this.details.address.city}`
        : '';
    },
    phone: {
      get() {
        return this.formatPhone(
          this.details.contact ? this.details.contact.phone : '',
        );
      },
      set(val) {
        this.details.contact.phone = val;
      },
    },
    contactName: {
      get() {
        return this.details.contact ? this.details.contact.contact_name : '';
      },
      set(val) {
        this.details.contact.contact_name = val;
      },
    },
    email: {
      get() {
        return this.details.contact ? this.details.contact.email : '';
      },
      set(val) {
        this.details.contact.email = val;
      },
    },
    status() {
      return this.details.status
        ? this.details.status.charAt(0).toUpperCase()
            + this.details.status.slice(1)
        : '';
    },
    area: {
      get() {
        return this._areas.find((area) => area.value === this.details.area_id);
      },
      set(val) {
        this.details.area_id = val;
      },
    },
  },
  methods: {
    onPlaceChanged(e) {
      this.details.address.address_1 = `${e.street_number} ${e.route}`;
      this.details.address.city = e.locality;
      this.details.address.state = e.administrative_area_level_1;
      this.details.address.zip = e.postal_code;
      this.details.lat = e.latitude;
      this.details.lng = e.longitude;
    },
  },
};
</script>
